import axios from "axios";

function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

function currentTenantId() {
  try {
    const profile = JSON.parse(localStorage.getItem("associationProfile") || "{}");
    return profile.tenant_id || (profile.association && profile.association.tenant_id) || null;
  } catch (error) {
    return null;
  }
}

export async function registerBoaruaPush() {
  const publicKey = process.env.VUE_APP_WEB_PUSH_PUBLIC_KEY;

  if (localStorage.getItem("boaruaPushDisabled") === "true") {
    return false;
  }

  if (!publicKey || !("serviceWorker" in navigator) || !("PushManager" in window)) {
    return false;
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    return false;
  }

  const registration = await navigator.serviceWorker.register("/boarua-push-sw.js");
  let subscription = await registration.pushManager.getSubscription();

  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }

  await axios.post("/notification-subscriptions", {
    ...subscription.toJSON(),
    tenant_id: currentTenantId(),
    platform: "pwa",
  });

  return true;
}

export async function unregisterBoaruaPush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    localStorage.setItem("boaruaPushDisabled", "true");
    return false;
  }

  const registration = await navigator.serviceWorker.getRegistration("/boarua-push-sw.js");
  const subscription = registration ? await registration.pushManager.getSubscription() : null;

  if (subscription) {
    await axios.delete("/notification-subscriptions", {
      data: {
        endpoint: subscription.endpoint,
      },
    });

    await subscription.unsubscribe();
  }

  localStorage.setItem("boaruaPushDisabled", "true");
  return true;
}
